import { BrowserRouter } from 'react-router-dom';
import { getEncryptedClientId } from './helper';
import { isNonClientRoute } from './nonClientRoutes';
import encryptDecrypt from '@/utils/encryptDecrypt';

const originalPush = window.history.pushState.bind(window.history);
const originalReplace = window.history.replaceState.bind(window.history);

const prependClientId = (path: string | URL | null | undefined): string => {
  if (path instanceof URL) {
    path = path.pathname + path.search + path.hash;
  }

  if (!path || typeof path !== 'string') return path as string;
  if (isNonClientRoute(path)) return path;

  // If the path's first segment already decrypts to a valid client id,
  // it's already client-scoped (possibly a DIFFERENT client than the
  // current one, e.g. mid client-switch) — leave it untouched.
  const firstSegment = path.replace(/^\//, '').split('/')[0];
  if (firstSegment) {
    const decrypted = encryptDecrypt.decryptClientId(firstSegment);
    if (decrypted) return path;
  }

  const encryptedId = getEncryptedClientId();
  if (!encryptedId) return path;

  const subPath = path.replace(/^\//, '');
  return subPath ? `/${encryptedId}/${subPath}` : `/${encryptedId}`;
};

window.history.pushState = (state, title, url) => {
  if (url !== null && url !== undefined) {
    url = prependClientId(url as string | URL);
  }
  originalPush(state, title, url);
};

window.history.replaceState = (state, title, url) => {
  if (url !== null && url !== undefined) {
    url = prependClientId(url as string | URL);
  }
  originalReplace(state, title, url);
};

export const ClientAwareRouter = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <BrowserRouter>{children}</BrowserRouter>;
};
